const React = require('react');

const {
  initFilter,
  getFilterParams
} = require('../../../../../dumb/IntervalFilterCustom');
const virtualOutputComponentProvider = require('../../../../../../utils/virtualOutputComponentProvider');
const {apiAdminNuveiReconciliationList} = require('../../../../../../api/admin/transactions');

const {ReconTableDisplay, ReconTableItemDisplay} = require('../../../../../dumb/AdminHelpers/AdminTrx')

const filter$ = initFilter();

module.exports = virtualOutputComponentProvider({
  state: {
    filter: filter$,
  },
  rowHeight: 60,
  request: apiAdminNuveiReconciliationList,
  getParams: getFilterParams('lifeflow', 'merchant_id'),
  wrapper(render, setState, self) {
    return (state, props) => {
      return (
        <ReconTableDisplay
          self={self}
          filter$={filter$}
          items={render(ReconTableItemDisplay, props)}
          fullSize
        />
      );
    };
  },
});
